<template>
<div class="filesVue">
  <div class="o-main-content-area c-responsive-fixwidth">
             <!-- Heading Section -->
             <div class="row">
                 <div class="col-md-7">
                     <h1 class="h1">File Repository</h1>
                     <div class="o-subtitleHeading">
                         <p class="h3"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Files uploaded to the repository will be accessible to all powerusers.</p>

                     </div>
                 </div>
                 <div class="col-md-5 text-right">
                     <ul class="o-filter-area">

                        <li class="o-search-field">
                            <div class="input-group stylish-input-group">
                                <input v-on:input="updateValue" v-model="searchFileName" type="text" class="form-control" placeholder="Search">
                                <span class="input-group-addon">
                                     <button @click="updateValue" type="submit">
                                     <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                </button>
                                </span>
                            </div>
                        </li>

                         <li :class="{'isDisabled':!getPower('addDocuments')}"><a href="javascript: void(0)" @click="addNewFilesModal()"  class="c-solid-btn c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add New Files</a></li>
                     </ul>
                 </div>
             </div>

             <div v-loading="loading" class="o-filesList" v-if="!toggleSearch">
                 <div v-for="(filesbyday, key, index) in filesList" v-if="filesbyday.length != 0" class="o-filesListBox">
                     <div class="filesLisBoxTitle">
                         <h4 class="h3">{{getDate(key)}}</h4>
                     </div>
                     <div class="c-common-box-shadow c-bg-white">
                         <div class="row">

                             <div class="col-md-12">
                                 <div class="filesLisBoxInfo o-no-padding">
                                     <ul @click="show">
                                          <li v-for="(file, listid) in filesbyday">
                                             <div class="fileIcon"><i class="fa fa-file-o" aria-hidden="true"></i></div>
                                             <div class="fileName">{{file.filename}}</div>
                                             <div class="fileControlIcon">
                                                 <a href="javascript: void(0)" @click="show(index , listid, file.filename, file.path)" class="o-files-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                 <a :href="base_url+'auth/'+ decodeFileId(file.id)+'/download'" :class="'files'+index+listid" download class="o-files-download"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                                                 <a :class="{'isDisabled':!getPower('addDocuments')}" href="javascript: void(0)" @click="deleteAtteachment(file.id)" class="o-files-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                             </div>
                                             <div :class="'images'+index+listid" v-viewer="{movable: true}">
                                              <img :src="getImageFullPath(file.path)" :key="getImageFullPath(file.path)" v-show="false">
                                            </div>
                                          </li>
                                     </ul>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
                 <div v-if="filesList.length <= 0 && afterApi" class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3">
                   <div class="col-md-12 no-job-dispaly">
                      <i class="fa fa-frown-o" aria-hidden="true"></i>
                      <br />
                       No Data Stored
                   </div>
                 </div>
             </div>
             <div v-loading="loading" class="o-filesList" v-if="toggleSearch">
                 <div class="o-filesListBox">
                     <div class="c-common-box-shadow c-bg-white">
                         <div class="row">
                             <div class="col-md-12">
                                 <div class="filesLisBoxInfo o-no-padding">
                                     <ul>
                                          <li v-for="(file, listid) in fileSearchData">
                                             <div class="fileIcon"><i class="fa fa-file-o" aria-hidden="true"></i></div>
                                             <div class="fileName">{{file.filename}}</div>
                                             <div class="fileControlIcon">
                                                 <a href="javascript: void(0)" @click="show(0 , listid, file.filename, file.path)" class="o-files-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                 <a :href="base_url+'auth/'+ decodeFileId(file.id)+'/download'" :class="'files0'+listid"  class="o-files-download"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                                                 <a href="javascript: void(0)" @click="deleteAtteachment(file.id)" class="o-files-delete"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                             </div>
                                             <div :class="'images0'+listid" v-viewer="{movable: true}">
                                              <img :src="getImageFullPath(file.path)" :key="getImageFullPath(file.path)" v-show="false">
                                            </div>
                                          </li>

                                     </ul>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
                 <div v-if="fileSearchData.length <= 0 && afterApi" class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3">
                   <div class="col-md-12 no-job-dispaly">
                      <i class="fa fa-frown-o" aria-hidden="true"></i>
                      <br />
                       No Data Stored
                   </div>
                 </div> 
             </div>

         </div>
      <modal name="add-files"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
        <div id="" class="modal-add-call" tabindex="-1" role="dialog">
               <div  role="document">
                   <div class="modal-content o-common-modal-content">
                       <div class="modal-header u-no-border text-center modal-header--heading">
                           <button @click="closeNewFileModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                           <h1 class="modal-title">Add Files</h1>
                       </div>
                       <div class="modal-body c-common-box-shadow o-modal-body">
                           <div class="row">
                               <div class="col-md-12">
                                    <ul class="o-filter-area">
                                        <li>
                                            <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add Files</button>
                                                <input type="file" @change="addFileToList($event)" />
                                            </label>
                                        </li>
                                        <li><a  href="javascript: void(0)" @click="uploadImage()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i> Start Upload</a></li>
                                        <li><a href="javascript: void(0)" @click="cancelUpload()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel Upload</a></li>
                                        <li><a href="javascript: void(0)" @click="deleteDocuments()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a></li>
                                    </ul>
                                </div>
                                <div class="col-md-12">
                                    <div class="upload-table-list o-uploaded-box c-common-box-shadow">
                                        <div class="calls-table-row o-upload-devider" v-for="(img,key) in new_files" v-loading.this.lock="img.uploading">
                                            <div class="calls-table-cell">
                                                <div class="checkbox o-custom-radio">
                                                    <label>
                                                        <input type="checkbox" :name="key" value="" v-model="img.status">
                                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    </label>
                                                </div>
                                            </div>
                                        <div class="calls-table-cell">

                                            <div class="calls-table-cell-inner-table">
                                                <div class="o-accordion-subtext user-icon o-uploaded-image o-no-padding-left">
                                                    <div class="o-post-logged o-post-logged--table-user">
                                                        <div class="o-user-profile-img o-user-profile-img--upload">
                                                            <img v-if="!img.fileExtension" :src="img.img">
			                                                <img v-else src="static/assets/images/Document-icon.png">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <div>{{img.name}}</div>
                                                </div>
                                            </div>
                                                <el-progress :percentage="img.progress" :status="(img.progress == 100)?'success':''"></el-progress>
                                        </div>
                                    </div>
                                    <div v-if="new_files.length == 0" class="">
                                        <div class="o-attachment-strip">Upload your Documents</div>
                                    </div>
                                </div>
                            </div>
                           </div>

                       </div>
                       <div class="modal-footer text-center">
                          <div v-if="new_files.length > 0" class="col-md-12">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="cancelSave()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="uploadSave()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                </li>
                            </ul>
                        </div>
                       </div>


                   </div>
                   <!-- /.modal-content -->
               </div>

               <!-- /.modal-dialog -->
        </div>
      </modal>
</div>
</template>
<script>
    import dateTimeConvert from '../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';
    import {
        bus
    } from '../main';
    import service from '../services.js';
    import 'viewerjs/dist/viewer.css';
    import Viewer from 'v-viewer';
    import Vue from 'vue';
    Vue.use(Viewer);
    export default {
        data() {
            return {
                loading:false,
                afterApi:false,
                pictureExtension: false,
                baseImageUrl: '',
                new_files: [],
                selected: '',
                filesList: {},
                searchFileName: '',
                fileSearchData: [],
                attachmentList: [],
                toggleSearch: false,
                // new_files: [],
                base_url: global[0].BASE_URL
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                currentEmployeeID: 'currentEmployeeID',
                employeeId: 'employeeId',
                userId: 'userID',
                userName: 'userName',
                userFullName: 'userFullName',
            })
        },
        methods: {
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            decodeFileId(id){
                return btoa(id);
            },
            show(index, listid, fileName, path) {
                if (listid != undefined) {
                    var extension = fileName.split('.').pop();
                    if (['jpg', 'jpeg', 'ico', 'png', 'svg', 'tif', 'tiff', 'gif', 'bmp'].indexOf(extension) > -1) {
                        this.$el.querySelector('.images' + index + listid).$viewer.show();
                    } else if (['xls', 'csv', 'xlsx', 'xlr', 'ods', 'doc', 'odt', 'rtf', 'tex', 'wps', 'wks'].indexOf(extension) > -1) {
                        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + path);
                        // window.open('https://view.officeapps.live.com/op/view.aspx?src=' + this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    } else if (['pdf', 'text', 'txt'].indexOf(extension) > -1) {
                        window.open('https://docs.google.com/viewer?url=' + path);
                        // window.open('https://docs.google.com/viewer?url=' + this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    } else {
                        window.open(this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    }
                }
            },
            addNewFilesModal() {
                this.$modal.show("add-files");
            },
            closeNewFileModal() {
                this.$modal.hide("add-files");
            },
            getDate(dateTime) {
                //return dateTimeConvert.globalDate(dateTime);
                //var date = dateTimeConvert.extractDateOnly(dateTime);
                return dateTimeConvert.extractDateOnly(dateTime);
            },

            addFileToList(e) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        //console.log(e);
                        img = e.target.result;
                        this.new_files.push({
                            'img': img,
                        });
                    }
                    //console.log(reader);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            deleteAtteachment(id) {
                this.$confirm('ATTACHMENT will be removed from the FILES. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('attachment/destroy', {
                        'attachment_id': id
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.getAllUserAttachments();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            getAllUserAttachments() {
                this.$Progress.start();
                this.loading=true;
                this.afterApi=false;
                service.get('attachment/getUserAttachments', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userID': this.userID,
                }).
                then((res) => {
                    this.$Progress.finish();
                    this.filesList = res.data.result;
                    this.loading=false;
                    this.afterApi=true;
                    //console.log(this.filesList);
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterApi=true;
                });
            },
            // onUpdateOrAdd() {
            //     bus.$emit('onUpdateOrAdd', "Msg");
            // },
            addFileToList(e) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 10000000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files.push({
                                'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report',
                                'fileExtension': this.setPicture(type[0])
                            });
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 10 MB'
                        });
                    }
                }
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            uploadImage() {
                //console.log(this.new_files);
                for (var i = 0; i < this.new_files.length; i++) {

                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                        this.new_files[i].progress = 20;
                        this.uploadService(this.new_files[i]).then((path) => {
                            //console.log(path);
                        }).catch((err) => {
                            console.log(err);
                        });

                    }
                    //console.log(this.new_files);
                }
            },
            uploadService(img) {
                img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            resolve(res);
                            img.path = res.data.result.path;
                            img.progress = 100;
                            img.uploaded = true;
                        }).catch((err) => {
                            this.$notify.error({
                                title: this.$t('error'),
                                message: 'Something went wrong!'
                            });
                            reject(err);
                        });
                });
                return promise1;

            },
            uploadSave() {
                let self = this;
                //console.log(this.new_files);
                let unUploadFile = this.new_files.filter(function(file) {
                    //console.log(file.uploaded);
                    return (file.uploaded == false);
                });
                //console.log(unUploadFile);
                if (unUploadFile.length > 0) {
                    this.$confirm('Some file are still not uploaded. Do you want to save all files ?', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        type: 'warning'
                    }).then(() => {
                        this.new_files.forEach(function(file) {
                            if (!file.status) {
                                file.status = true;
                            }
                        });
                        // Upload un-uploaded files.
                        for (var i = 0; i < this.new_files.length; i++) {

                            if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                                this.new_files[i].progress = 20;
                                this.uploadService(this.new_files[i]).then((path) => {

                                    //save all file in database.
                                    for (var i = 0; i < this.new_files.length; i++) {
                                        let activityData = {
                                            uploader_id: this.userId,
                                            uploaded_by: this.userFullName,
                                        };
                                        let fromData = {
                                            attachable_id: this.currentEmployeeID,
                                            created_by: this.employeeId,
                                            attachable_type: 'employee',
                                            filename: this.new_files[i].name,
                                            description: 'Employee Document',
                                            label: this.new_files[i].label,
                                            path: this.new_files[i].path,
                                            activity: JSON.stringify(activityData)
                                        };
                                        this.saveService(fromData).then((res) => {
                                            //console.log(res);

                                            this.$message({
                                                type: 'success',
                                                message: 'File saved successfully'
                                            });
                                            this.new_files = [];
                                        }).catch((err) => {
                                            console.log(err);
                                        });
                                    }

                                }).catch((err) => {
                                    console.log(err);
                                });

                            }
                            //console.log(this.new_files);
                        }
                        //console.log("data");
                    }).catch(() => {

                        /*delete un-uploaded files.*/
                        this.new_files.forEach(function(file, key) {
                            //console.log(key);
                            if (!file.uploaded) {
                                self.new_files.splice(key, 1);
                            }
                        });

                        /* save uploaded files.*/
                        for (var i = 0; i < this.new_files.length; i++) {
                            let activityData = {
                                uploader_id: this.userId,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: this.currentEmployeeID,
                                created_by: this.employeeId,
                                attachable_type: 'employee',
                                filename: this.new_files[i].name,
                                description: 'Employee Document',
                                label: this.new_files[i].label,
                                path: this.new_files[i].path,
                                activity: JSON.stringify(activityData)
                            };
                            this.saveService(fromData).then((res) => {
                                this.$message({
                                    type: 'success',
                                    message: 'File saved successfully'
                                });
                                this.new_files = [];
                            }).catch((err) => {
                                console.log(err);
                            });
                        }
                    });

                } else {
                    //console.log("uploaded");
                    for (var i = 0; i < this.new_files.length; i++) {
                        let activityData = {
                            uploader_id: this.userId,
                            uploaded_by: this.userFullName,
                        };
                        let fromData = {
                            attachable_id: this.currentEmployeeID,
                            created_by: this.employeeId,
                            attachable_type: 'employee',
                            filename: this.new_files[i].name,
                            description: 'Employee Document',
                            label: this.new_files[i].label,
                            path: this.new_files[i].path,
                            activity: JSON.stringify(activityData)
                        };
                        this.saveService(fromData).then((res) => {
                            this.$message({
                                type: 'success',
                                message: 'File saved successfully'
                            });
                            this.new_files = [];
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
                //document.reload();
                //this.onUpdateOrAdd();
                this.closeNewFileModal();
                this.getAllUserAttachments();
            },
            saveService(data) {
                //img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment', data, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            resolve(res);
                            //this.onUpdateOrAdd();
                            this.closeNewFileModal();
                            this.getAllUserAttachments();
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },
            cancelSave() {
                this.new_files = [];
            },
            cancelUpload() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].uploaded == false) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },
            deleteDocuments() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].status == true) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },
            updateValue() {
                if (this.searchFileName.length > 2) {
                    this.toggleSearch = true;
                    this.loading=true;
                    this.afterApi=false;
                    service.get('attachment/searchFile', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'fileName': this.searchFileName,
                        })
                        .then((res) => {
                            this.fileSearchData = res.data.result;
                            //console.log("resp", this.fileSearchData);
                            this.loading=false;
                            this.afterApi=true;
                        }).catch((err) => {
                            console.log(err);
                            this.loading=false;
                            this.afterApi=true;
                        });
                } else {
                    this.toggleSearch = false;
                    this.getAllUserAttachments();
                }

            },
            deleteAtteachment(id) {
                this.$confirm('ATTACHMENT will be removed from the FILES. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('attachment/destroy', {
                        'attachment_id': id
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        //this.onUpdateOrAdd();
                        this.getAllUserAttachments();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            getImageFullPath(path) {
                return path;
            }
        },
        created() {
            this.baseImageUrl = global[0].IMAGE_URL;
            this.getAllUserAttachments();
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/files.vue